import clsx from 'clsx'
import { FC } from 'react'
import { ClassName } from 'types/props'

import Icon from '../../Icon'
import classes from './index.module.scss'

interface Props extends ClassName {
  onClick: () => void
}
export const ClearButton: FC<Props> = ({ children, className, onClick }) => (
  <button className={clsx(classes.root, className)} type="button" onClick={onClick}>
    <Icon name="circleX" />
    {children}
  </button>
)
